// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Form Validation & Errors ===== */
.field-error {
  border: 1px solid #d32f2f !important;
  border-radius: 4px;
}

.input-error {
  border: 1px solid #d32f2f !important;
  border-radius: 4px;
}

:host ::ng-deep .input-error.p-inputtext {
  border: 1px solid #d32f2f !important;
}

.error-message {
  color: #d32f2f;
  font-size: 0.85rem;
  margin-top: 0.25rem;
  display: block;
}

/* ===== Footer ===== */
.privacy-footer {
  width: 100%;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  font-family: 'Open Sans', 'Salesforce Sans', sans-serif;
}

.privacy-footer-inner {
  max-width: 38rem;
  margin: 0 auto;
  padding: 0 1rem 2rem;
}

.powered-by {
  text-align: right;
  font-size: 0.82rem;
  color: #777;
  padding: 10px 0 6px;
}

.onetrust-brand {
  font-size: 1.3rem;
  font-weight: 700;
  color: #34a853;
  letter-spacing: -0.5px;
}

.footer-divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0 0 1.1rem;
}

.footer-body {
  font-size: 0.85rem;
  color: #333;
  line-height: 1.6;
  margin: 0 0 0.85rem;
}

.footer-link {
  color: var(--color-green);
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}

/* IQVIA dark-navy banner */
.iqvia-banner {
  width: 100%;
  background-color: #1a1f5e;
  padding: 16px 24px;
  box-sizing: border-box;
}

.iqvia-banner-inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.iqvia-logo {
  height: 44px;
  width: auto;
  filter: brightness(0) invert(1);
  object-fit: contain;
}

.privacy-form-container {
  box-sizing: border-box; 
  width: 100%;
  max-width: 38rem;
  margin: 0 auto;
  padding: 1rem;
  color: #696969;
  background: #fff; 
}

.privacy-form-container,
.privacy-form-container * {
  box-sizing: border-box; 
}

.privacy-form-container > form {
  width: 100%;
  min-height: 90vh;
}

.form-group {
  margin-bottom: 14px;
}

.form-group:has(textarea) {
  margin-bottom: 8px;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 18px 0 10px;
}

.field-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #000;
  text-transform: uppercase;
}

.field-label.required::before {
  content: "* ";
  color: #d9534f;
  font-weight: 700;
}

.rights-label-row {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  cursor: help;
}

.rights-tooltip-trigger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: #2f3337;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.rights-tooltip-trigger:focus-visible {
  outline: 2px solid #4f8cff;
  outline-offset: 2px;
}

.rights-tooltip {
  position: absolute;
  left: 0;
  bottom: calc(100% + 12px);
  min-width: 300px;
  max-width: 400px;
  background: #2f3337;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 1.45;
  padding: 14px 18px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
  opacity: 0;
  visibility: hidden;
  transform: translateY(4px);
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
  pointer-events: none;
  z-index: 50;
}

.rights-tooltip::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #2f3337;
}

.rights-label-row:hover .rights-tooltip,
.rights-label-row:focus-within .rights-tooltip,
.rights-label-row .field-label:hover + .rights-tooltip-trigger + .rights-tooltip,
.rights-label-row .field-label:focus + .rights-tooltip-trigger + .rights-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-wrap {
  position: relative;
}

.dropdown-clear-btn {
  position: absolute;
  top: 50%;
  right: 0.55rem;
  z-index: 4;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #888888;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

.dropdown-clear-btn:hover {
  color: #666666;
}

/* ── Custom rights combobox ──────────────────────────────── */
.rights-combobox {
  position: relative;
}

.rights-search-box {
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  cursor: text;
}

.rights-search-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 8px 12px;
  font-size: 13px;
  font-family: inherit;
  background: transparent;
}

.rights-dropdown-panel {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  max-height: 240px;
  overflow-y: auto;
}

.rights-dropdown-item {
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
}

.rights-dropdown-item:last-child { border-bottom: none; }
.rights-dropdown-item:hover { background: #f5f5f5; }

.rights-dropdown-empty {
  padding: 8px 14px;
  font-size: 13px;
  color: #999;
}

/* Chips */
.rights-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.rights-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1.5px solid #b0b0b0;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  background: #fff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.rights-chip.active {
  border-color: #666;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.chip-remove {
  font-size: 16px;
  line-height: 1;
  color: #777;
  cursor: pointer;
}

.chip-remove:hover { color: #333; }

/* Rights detail panel */
.rights-description {
  margin: 14px 0 28px;
}

.rights-description-item {
  margin-bottom: 14px;
}

.rights-description-item:last-child {
  margin-bottom: 0;
}

.rights-short-title {
  margin: 0 0 6px;
  font-size: 1rem;
  font-weight: 700;
  color:rgb(0, 0, 0);
  line-height: 1;
  word-wrap: break-word;
}

.rights-description h3 {
  margin: 0 0 8px;
  font-size: 1rem;
  font-weight: 500;
  color: rgb(20, 11, 66);
  font-style: italic;
}

.rights-description p {
  margin: 0;
  line-height: 1.65;
  font-size: 13px;
  font-style: italic;
  color: #1f2557;
}

.submit-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

:host ::ng-deep {

  .w-full,
  .p-inputtext,
  .p-dropdown,
  .p-multiselect,
  .p-inputtextarea {
    width: 100%;
  }

  .p-inputtext,
  .p-dropdown,
  .p-multiselect {
    height: 34px;
  }

  .p-inputtextarea {
    min-height: 48px;
    resize: vertical;
  }

  .p-dropdown,
  .p-inputtext,
  .p-inputtextarea,
  .p-multiselect {
    border: 1px solid #b3b3b3;
    border-radius: 4px;
  }

  .country-dropdown.p-dropdown {
    min-height: 34px;
    align-items: center;
  }

  .country-dropdown .p-dropdown-label {
    padding: 7px 12px;
    font-size: 13px;
  }

  .country-dropdown .p-dropdown-trigger,
  .relationship-dropdown .p-dropdown-trigger {
    display: none;
  }

  .country-dropdown .p-dropdown-clear-icon,
  .relationship-dropdown .p-dropdown-clear-icon {
    display: none !important;
  }

  .country-dropdown .p-dropdown-clear-icon {
    right: 0.9rem;
    font-size: 1.1rem;
    color: #808080;
  }

  .country-dropdown .p-dropdown-filter-icon,
  .country-dropdown .p-dropdown-search-icon,
  .relationship-dropdown .p-dropdown-filter-icon,
  .relationship-dropdown .p-dropdown-search-icon {
    display: none !important;
  }

  .relationship-dropdown .p-dropdown-clear-icon {
    right: 0.9rem;
    font-size: 1.1rem;
    color: #808080;
  }

  .country-dropdown .p-dropdown-label,
  .relationship-dropdown .p-dropdown-label {
    padding-right: 2.6rem;
  }

  .country-dropdown .p-dropdown-panel {
    min-width: 100%;
  }

  .country-dropdown .p-dropdown-items {
    max-height: 220px;
    padding-left: 0px !important;
  }

  .relationship-dropdown.p-dropdown {
    min-height: 34px;
    align-items: center;
  }

  .relationship-dropdown .p-dropdown-label {
    padding: 7px 12px;
    font-size: 13px;
  }

  .relationship-dropdown .p-dropdown-clear-icon {
    right: 0.9rem;
    font-size: 1.1rem;
    color: #808080;
  }

  .relationship-dropdown .p-dropdown-panel {
    min-width: 100%;
  }

  .relationship-dropdown .p-dropdown-items {
    max-height: 220px;
    padding-left: 0px !important;
  }

  .p-button {
    background: #9a94b5;
    border-color: #9a94b5;
    min-width: 120px;
    font-weight: 600;
  }

  .p-button:hover {
    background: #8780a4;
    border-color: #8780a4;
  }

  .p-multiselect-token {
    border-radius: 25px;
    padding: 8px 12px;
  }

  .p-dropdown-items-wrapper{
     margin-top: 0px !important;
     padding-left: 0.5rem !important;
  }

  ol, ul {
    padding-left: 0;
  }
} 
.captcha-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* moves captcha to right */
  margin-top: 12px;
} 
.captcha-container .text-danger {
  margin-top: 6px;
  text-align: right;
}
.navbar {
    padding: 0 1rem;
    line-height: 40px;
}
.navbar-expand-lg .navbar-nav .nav-link {
    padding: 8px 25px;
    font-size: 15px;
}

.lsr-bg{
    background-image: linear-gradient(to right, var(--color-purple) 20%, var(--color-green) 48%, var(--color-green) 52%,  var(--color-purple) 100%);
} 
:host ::ng-deep h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

:host ::ng-deep h2 {
  margin-top: 36px;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host ::ng-deep .header {
  display: flex;
  margin-top: 30px;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple); 
  justify-content: center;
}

:host ::ng-deep p,
:host ::ng-deep ul,
:host ::ng-deep ol {
  font-size: 16px;
  line-height: 1.18;
}

:host ::ng-deep a {
  color: var(--color-green);
}

:host ::ng-deep ul,
:host ::ng-deep ol {
  padding-left: 24px;
}

:host li + li {
  margin-top: 8px;
}
:host ::ng-deep .lsr-link {
  font-weight: 600;
  text-decoration: underline; 
  /* purple */
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
} 
 :host ::ng-deep .numericText
  {
    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: "lnum" 1, "tnum" 1;
  }
 
a.primary-button,
a.primary-button:link,
a.primary-button:visited,
a.primary-button:hover,
a.primary-button:active,
a.primary-button:focus {
  color: #fff !important;
  text-decoration: none !important;
}
:host ::ng-deep .primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}
.form-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
:host {
  display: block;
}

:host .hero--inner {
  min-height: 200px;
  position: relative;
  padding-right: 0;
}

:host .hero--inner .hero__image,
:host .hero--inner > img {
  position: absolute;
  z-index: 1;
  right: 84px;
  top: 0;
  width: 494px;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: right top;
  pointer-events: none;
}
:host .privacy-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  
  padding: 5px var(--space-page-x) 30px;
}

.footerSection{
   width: 100%;
  display: flex;
  flex-direction: column;
   padding: 30px var(--space-page-x) 0px;
   font-size: 14px;
}
.privacyfont{
   font-size: 14px;
  margin-top: 10px; 
  padding: 0px var(--space-page-x) 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/privacy-policy-form/privacy-policy-form.component.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,2EAA2E;EAC3E,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,WAAW;AACb;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA,qBAAqB,WAAW,EAAE;;AAElC,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE;;;;;IAKE,WAAW;EACb;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;;IAIE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;KACG,0BAA0B;KAC1B,+BAA+B;EAClC;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB,EAAE,2BAA2B;EAClD,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+IAA+I;AACnJ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;CACC;;IAEG,8CAA8C;IAC9C,yCAAyC;EAC3C;;AAEF;;;;;;EAME,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qCAAqC;EACrC,uGAAuG;AACzG;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;;EAEtB,qCAAqC;AACvC;;AAEA;GACG,WAAW;EACZ,aAAa;EACb,sBAAsB;GACrB,qCAAqC;GACrC,eAAe;AAClB;AACA;GACG,eAAe;EAChB,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":["/* ===== Form Validation & Errors ===== */\r\n.field-error {\r\n  border: 1px solid #d32f2f !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n.input-error {\r\n  border: 1px solid #d32f2f !important;\r\n  border-radius: 4px;\r\n}\r\n\r\n:host ::ng-deep .input-error.p-inputtext {\r\n  border: 1px solid #d32f2f !important;\r\n}\r\n\r\n.error-message {\r\n  color: #d32f2f;\r\n  font-size: 0.85rem;\r\n  margin-top: 0.25rem;\r\n  display: block;\r\n}\r\n\r\n/* ===== Footer ===== */\r\n.privacy-footer {\r\n  width: 100%;\r\n  background: #fff;\r\n  border-top: 1px solid #e0e0e0;\r\n  font-family: 'Open Sans', 'Salesforce Sans', sans-serif;\r\n}\r\n\r\n.privacy-footer-inner {\r\n  max-width: 38rem;\r\n  margin: 0 auto;\r\n  padding: 0 1rem 2rem;\r\n}\r\n\r\n.powered-by {\r\n  text-align: right;\r\n  font-size: 0.82rem;\r\n  color: #777;\r\n  padding: 10px 0 6px;\r\n}\r\n\r\n.onetrust-brand {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  color: #34a853;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.footer-divider {\r\n  border: none;\r\n  border-top: 1px solid #e0e0e0;\r\n  margin: 0 0 1.1rem;\r\n}\r\n\r\n.footer-body {\r\n  font-size: 0.85rem;\r\n  color: #333;\r\n  line-height: 1.6;\r\n  margin: 0 0 0.85rem;\r\n}\r\n\r\n.footer-link {\r\n  color: var(--color-green);\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* IQVIA dark-navy banner */\r\n.iqvia-banner {\r\n  width: 100%;\r\n  background-color: #1a1f5e;\r\n  padding: 16px 24px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.iqvia-banner-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.iqvia-logo {\r\n  height: 44px;\r\n  width: auto;\r\n  filter: brightness(0) invert(1);\r\n  object-fit: contain;\r\n}\r\n\r\n.privacy-form-container {\r\n  box-sizing: border-box; \r\n  width: 100%;\r\n  max-width: 38rem;\r\n  margin: 0 auto;\r\n  padding: 1rem;\r\n  color: #696969;\r\n  background: #fff; \r\n}\r\n\r\n.privacy-form-container,\r\n.privacy-form-container * {\r\n  box-sizing: border-box; \r\n}\r\n\r\n.privacy-form-container > form {\r\n  width: 100%;\r\n  min-height: 90vh;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.form-group:has(textarea) {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.section-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  margin: 18px 0 10px;\r\n}\r\n\r\n.field-label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #000;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.field-label.required::before {\r\n  content: \"* \";\r\n  color: #d9534f;\r\n  font-weight: 700;\r\n}\r\n\r\n.rights-label-row {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  cursor: help;\r\n}\r\n\r\n.rights-tooltip-trigger {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #fff;\r\n  background: #2f3337;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.rights-tooltip-trigger:focus-visible {\r\n  outline: 2px solid #4f8cff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.rights-tooltip {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: calc(100% + 12px);\r\n  min-width: 300px;\r\n  max-width: 400px;\r\n  background: #2f3337;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  line-height: 1.45;\r\n  padding: 14px 18px;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(4px);\r\n  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;\r\n  pointer-events: none;\r\n  z-index: 50;\r\n}\r\n\r\n.rights-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: -10px;\r\n  transform: translateX(-50%);\r\n  border-left: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n  border-top: 10px solid #2f3337;\r\n}\r\n\r\n.rights-label-row:hover .rights-tooltip,\r\n.rights-label-row:focus-within .rights-tooltip,\r\n.rights-label-row .field-label:hover + .rights-tooltip-trigger + .rights-tooltip,\r\n.rights-label-row .field-label:focus + .rights-tooltip-trigger + .rights-tooltip {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateY(0);\r\n}\r\n\r\n.dropdown-wrap {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-clear-btn {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 0.55rem;\r\n  z-index: 4;\r\n  transform: translateY(-50%);\r\n  width: 22px;\r\n  height: 22px;\r\n  padding: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  color: #888888;\r\n  font-size: 1.5rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.dropdown-clear-btn:hover {\r\n  color: #666666;\r\n}\r\n\r\n/* ── Custom rights combobox ──────────────────────────────── */\r\n.rights-combobox {\r\n  position: relative;\r\n}\r\n\r\n.rights-search-box {\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  cursor: text;\r\n}\r\n\r\n.rights-search-input {\r\n  width: 100%;\r\n  border: none;\r\n  outline: none;\r\n  padding: 8px 12px;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  background: transparent;\r\n}\r\n\r\n.rights-dropdown-panel {\r\n  position: absolute;\r\n  top: calc(100% + 2px);\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n  background: #fff;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\r\n  max-height: 240px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.rights-dropdown-item {\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.rights-dropdown-item:last-child { border-bottom: none; }\r\n.rights-dropdown-item:hover { background: #f5f5f5; }\r\n\r\n.rights-dropdown-empty {\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  color: #999;\r\n}\r\n\r\n/* Chips */\r\n.rights-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.rights-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  border: 1.5px solid #b0b0b0;\r\n  border-radius: 999px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #555;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.rights-chip.active {\r\n  border-color: #666;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\r\n}\r\n\r\n.chip-remove {\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  color: #777;\r\n  cursor: pointer;\r\n}\r\n\r\n.chip-remove:hover { color: #333; }\r\n\r\n/* Rights detail panel */\r\n.rights-description {\r\n  margin: 14px 0 28px;\r\n}\r\n\r\n.rights-description-item {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.rights-description-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.rights-short-title {\r\n  margin: 0 0 6px;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color:rgb(0, 0, 0);\r\n  line-height: 1;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.rights-description h3 {\r\n  margin: 0 0 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  color: rgb(20, 11, 66);\r\n  font-style: italic;\r\n}\r\n\r\n.rights-description p {\r\n  margin: 0;\r\n  line-height: 1.65;\r\n  font-size: 13px;\r\n  font-style: italic;\r\n  color: #1f2557;\r\n}\r\n\r\n.submit-section {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 24px;\r\n}\r\n\r\n:host ::ng-deep {\r\n\r\n  .w-full,\r\n  .p-inputtext,\r\n  .p-dropdown,\r\n  .p-multiselect,\r\n  .p-inputtextarea {\r\n    width: 100%;\r\n  }\r\n\r\n  .p-inputtext,\r\n  .p-dropdown,\r\n  .p-multiselect {\r\n    height: 34px;\r\n  }\r\n\r\n  .p-inputtextarea {\r\n    min-height: 48px;\r\n    resize: vertical;\r\n  }\r\n\r\n  .p-dropdown,\r\n  .p-inputtext,\r\n  .p-inputtextarea,\r\n  .p-multiselect {\r\n    border: 1px solid #b3b3b3;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .country-dropdown.p-dropdown {\r\n    min-height: 34px;\r\n    align-items: center;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-label {\r\n    padding: 7px 12px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-trigger,\r\n  .relationship-dropdown .p-dropdown-trigger {\r\n    display: none;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-clear-icon,\r\n  .relationship-dropdown .p-dropdown-clear-icon {\r\n    display: none !important;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-clear-icon {\r\n    right: 0.9rem;\r\n    font-size: 1.1rem;\r\n    color: #808080;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-filter-icon,\r\n  .country-dropdown .p-dropdown-search-icon,\r\n  .relationship-dropdown .p-dropdown-filter-icon,\r\n  .relationship-dropdown .p-dropdown-search-icon {\r\n    display: none !important;\r\n  }\r\n\r\n  .relationship-dropdown .p-dropdown-clear-icon {\r\n    right: 0.9rem;\r\n    font-size: 1.1rem;\r\n    color: #808080;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-label,\r\n  .relationship-dropdown .p-dropdown-label {\r\n    padding-right: 2.6rem;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-panel {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .country-dropdown .p-dropdown-items {\r\n    max-height: 220px;\r\n    padding-left: 0px !important;\r\n  }\r\n\r\n  .relationship-dropdown.p-dropdown {\r\n    min-height: 34px;\r\n    align-items: center;\r\n  }\r\n\r\n  .relationship-dropdown .p-dropdown-label {\r\n    padding: 7px 12px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .relationship-dropdown .p-dropdown-clear-icon {\r\n    right: 0.9rem;\r\n    font-size: 1.1rem;\r\n    color: #808080;\r\n  }\r\n\r\n  .relationship-dropdown .p-dropdown-panel {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .relationship-dropdown .p-dropdown-items {\r\n    max-height: 220px;\r\n    padding-left: 0px !important;\r\n  }\r\n\r\n  .p-button {\r\n    background: #9a94b5;\r\n    border-color: #9a94b5;\r\n    min-width: 120px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .p-button:hover {\r\n    background: #8780a4;\r\n    border-color: #8780a4;\r\n  }\r\n\r\n  .p-multiselect-token {\r\n    border-radius: 25px;\r\n    padding: 8px 12px;\r\n  }\r\n\r\n  .p-dropdown-items-wrapper{\r\n     margin-top: 0px !important;\r\n     padding-left: 0.5rem !important;\r\n  }\r\n\r\n  ol, ul {\r\n    padding-left: 0;\r\n  }\r\n} \r\n.captcha-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end; /* moves captcha to right */\r\n  margin-top: 12px;\r\n} \r\n.captcha-container .text-danger {\r\n  margin-top: 6px;\r\n  text-align: right;\r\n}\r\n.navbar {\r\n    padding: 0 1rem;\r\n    line-height: 40px;\r\n}\r\n.navbar-expand-lg .navbar-nav .nav-link {\r\n    padding: 8px 25px;\r\n    font-size: 15px;\r\n}\r\n\r\n.lsr-bg{\r\n    background-image: linear-gradient(to right, var(--color-purple) 20%, var(--color-green) 48%, var(--color-green) 52%,  var(--color-purple) 100%);\r\n} \r\n:host ::ng-deep h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n:host ::ng-deep h2 {\r\n  margin-top: 36px;\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host ::ng-deep .header {\r\n  display: flex;\r\n  margin-top: 30px;\r\n  font-size: 18px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple); \r\n  justify-content: center;\r\n}\r\n\r\n:host ::ng-deep p,\r\n:host ::ng-deep ul,\r\n:host ::ng-deep ol {\r\n  font-size: 16px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host ::ng-deep a {\r\n  color: var(--color-green);\r\n}\r\n\r\n:host ::ng-deep ul,\r\n:host ::ng-deep ol {\r\n  padding-left: 24px;\r\n}\r\n\r\n:host li + li {\r\n  margin-top: 8px;\r\n}\r\n:host ::ng-deep .lsr-link {\r\n  font-weight: 600;\r\n  text-decoration: underline; \r\n  /* purple */\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 12px 20px;\r\n} \r\n :host ::ng-deep .numericText\r\n  {\r\n    font-variant-numeric: lining-nums tabular-nums;\r\n    font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n  }\r\n \r\na.primary-button,\r\na.primary-button:link,\r\na.primary-button:visited,\r\na.primary-button:hover,\r\na.primary-button:active,\r\na.primary-button:focus {\r\n  color: #fff !important;\r\n  text-decoration: none !important;\r\n}\r\n:host ::ng-deep .primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n.form-actions {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n:host {\r\n  display: block;\r\n}\r\n\r\n:host .hero--inner {\r\n  min-height: 200px;\r\n  position: relative;\r\n  padding-right: 0;\r\n}\r\n\r\n:host .hero--inner .hero__image,\r\n:host .hero--inner > img {\r\n  position: absolute;\r\n  z-index: 1;\r\n  right: 84px;\r\n  top: 0;\r\n  width: 494px;\r\n  height: 100%;\r\n  max-width: none;\r\n  object-fit: cover;\r\n  object-position: right top;\r\n  pointer-events: none;\r\n}\r\n:host .privacy-content {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  \r\n  padding: 5px var(--space-page-x) 30px;\r\n}\r\n\r\n.footerSection{\r\n   width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n   padding: 30px var(--space-page-x) 0px;\r\n   font-size: 14px;\r\n}\r\n.privacyfont{\r\n   font-size: 14px;\r\n  margin-top: 10px; \r\n  padding: 0px var(--space-page-x) 10px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
